import { render, staticRenderFns } from "./HelpDeskTechnicianRequestView.vue?vue&type=template&id=35d39fde&"
import script from "./HelpDeskTechnicianRequestView.vue?vue&type=script&lang=js&"
export * from "./HelpDeskTechnicianRequestView.vue?vue&type=script&lang=js&"
import style0 from "./HelpDeskTechnicianRequestView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports